import React from "react";
import { Link } from "react-router-dom";
import {
  Wind,
  Flame,
  Ban,
  Waves,
  CloudHail,
  Cloud,
  Droplets,
  Sprout,
  Biohazard,
  ArrowRight,
} from "lucide-react";
import { services } from "../mock";

const iconMap = {
  Wind,
  Flame,
  Ban,
  Waves,
  CloudHail,
  Cloud,
  Droplets,
  Sprout,
  Biohazard,
};

// Map service.id from mock.js to the URL slug used in seoContent.js
const slugMap = {
  "wind-damage": "wind-damage",
  "fire-damage": "fire-damage",
  "denied-claims": "denied-or-underpaid-claims",
  "flood-damage": "flood-damage",
  "hail-damage": "hail-damage",
  "smoke-damage": "smoke-damage",
  "water-damage": "water-damage",
  "mold-damage": "mold-damage",
  "biohazard-bodily-fluid-claims-florida": "biohazard-bodily-fluid-claims-florida",
};

const Services = () => {
  return (
    <section id="services" className="bg-black py-20 md:py-28 relative">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-4">
            <span className="h-[2px] w-10 bg-[#E11D26]" />
            <span className="text-[#E11D26] text-xs sm:text-sm font-bold tracking-[0.25em] uppercase">
              What We Handle
            </span>
          </div>
          <h2
            className="text-white text-4xl sm:text-5xl md:text-6xl font-black uppercase leading-[0.95]"
            style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
          >
            Every Type Of <span className="text-[#E11D26]">Property Damage</span>
          </h2>
          <p className="mt-5 text-white/70 max-w-2xl">
            Serving homeowners and business owners across Tampa, Riverview,
            Brandon and the entire Tampa Bay region. Whatever the loss — we
            document, prove and fight for every dollar.
          </p>
        </div>

        <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-px bg-white/10 border border-white/10">
          {services.map((s) => {
            const Icon = iconMap[s.icon] || Wind;
            return (
              <article
                key={s.id}
                className="group bg-[#0A0A0A] hover:bg-[#141414] p-7 transition-colors flex flex-col"
              >
                <div className="h-14 w-14 rounded-sm flex items-center justify-center bg-[#E11D26]/10 border border-[#E11D26]/30 text-[#E11D26] mb-5 group-hover:bg-[#E11D26] group-hover:text-white transition-colors">
                  <Icon className="h-7 w-7" strokeWidth={1.8} />
                </div>
                <h3
                  className="text-white text-xl font-black uppercase tracking-wide"
                  style={{ fontFamily: "'Anton', 'Oswald', sans-serif" }}
                >
                  {s.title}
                </h3>
                <p className="mt-3 text-white/65 text-sm leading-relaxed flex-1">
                  {s.description}
                </p>
                <a
                  href={`/${slugMap[s.id] || s.id}`}
                  className="mt-5 inline-flex items-center gap-2 text-[#E11D26] hover:text-white text-xs font-bold tracking-[0.2em] uppercase transition-colors"
                >
                  Learn More
                  <ArrowRight className="h-4 w-4 transition-transform group-hover:translate-x-1" />
                </a>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
